import React from "react";
import {Form, Select} from "antd";
// import CrontabForm from "@src/components/Common/CrontabForm";

const scheduleOptions = [
    { label: "No automatic schedule", value: "none" },
    { label: "Every hour", value: "0 * * * *" },
    { label: "Every day", value: "0 0 * * *" },
    { label: "Every week", value: "0 0 * * 1" },
    { label: "Every month", value: "0 0 1 * *" },
];

const OptimiserForm = (form: any, disabled: boolean) => {
    const handleScheduleChange = (value: string) => {
        const currentExtraData = form.getFieldValue("extra_data") || {};
        if (value && value !== "none") {
            form.setFieldsValue({ extra_data: { ...currentExtraData, schedule_enabled: true, schedule_crontab: value } });
        } else {
            form.setFieldsValue({ extra_data: { ...currentExtraData, schedule_enabled: false, schedule_crontab: null } });
        }
    };

    const normalizeScheduleCrontab = (value: any) => {
        return value === "none" ? null : value;
    };

    return (
        <div style={{ paddingLeft: '0px' }}>
            <Form.Item name={["extra_data", "schedule_enabled"]} hidden initialValue={false}>
                <input type="hidden" />
            </Form.Item>
            <Form.Item name={["extra_data", "schedule_crontab"]} label="Schedule" style={{ marginBottom: '10px' }} initialValue="none" normalize={normalizeScheduleCrontab} getValueProps={(value) => ({ value: value ?? "none" })}>
                <Select placeholder="Select frequency" disabled={disabled} style={{ width: '50%' }} onChange={handleScheduleChange}>
                    {scheduleOptions.map(opt => (
                        <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>
                    ))}
                </Select>
            </Form.Item>
            {/* Leave it commented. For now, we just need a few selection dropdown on GUI */}
            {/* <CrontabForm form={form} namePrefix={["extra_data"]} disabled={disabled} /> */}
        </div>
    );
}

export default OptimiserForm;
